import User from '../models/User';
import _ from 'lodash';
import PopinSummary from '../models/PopinSummary';

/**
 *
 * the expected popins array contains popin arrays of strings
 * with the following structure:
 *
 * [ id, startTime, name, email, useCase, users, contributors, contributions ]
 *
 */

export const PopinSorts = {

  /**
   * @param {Array<any>} popins list
   * @param {boolean} reversed Pass true to reverse the sort
   * @return {Array<any>} sorted list
   */
  copySortedByStartTime (popins, reversed = false) {
    const result = _.sortBy(popins, 'start_time');
    return reversed ? _.reverse(result) : result;
  },
  /**
   * @param {Array<any>} popins list
   * @param {boolean} reversed Pass true to reverse the sort
   * @return {Array<any>} sorted list
   */
  copySortedByName (popins, reversed = false) {
    const result = _.sortBy(popins, u => User.getDisplayName(PopinSummary.getHero(u)).toLowerCase());
    return reversed ? _.reverse(result) : result;
  },

  /**
   * @param {Array<any>} popins list
   * @param {boolean} reversed Pass true to reverse the sort
   * @return {Array<any>} sorted list
   */
  copySortedByEmail (popins, reversed = false) {
    const result = _.sortBy(popins, u => User.getEmail(PopinSummary.getHero(u)).toLowerCase());
    return reversed ? _.reverse(result) : result;
  },

  /**
   * @param {Array<any>} popins list
   * @param {boolean} reversed Pass true to reverse the sort
   * @return {Array<any>} sorted list
   */
  copySortedByUseCase (popins, reversed = false) {
    const result = _.sortBy(popins, u => PopinSummary.getUseCase(u).toLowerCase());
    return reversed ? _.reverse(result) : result;
  },

  /**
   * @param {Array<any>} popins list
   * @param {boolean} reversed Pass true to reverse the sort
   * @return {Array<any>} sorted list
   */
  copySortedByUsers (popins, reversed = false) {
    const result = _.sortBy(popins, u => PopinSummary.getUsers(u));
    return reversed ? _.reverse(result) : result;
  },

  /**
   * @param {Array<any>} popins list
   * @param {boolean} reversed Pass true to reverse the sort
   * @return {Array<any>} sorted list
   */
  copySortedByActivities (popins, reversed = false) {
    const result = _.sortBy(popins, u => PopinSummary.getActivities(u));
    return reversed ? _.reverse(result) : result;
  }

};
